import React, { useState, useEffect } from "react";
import axios from "axios";
import urldata from "../../../../urldata";

import Button from "../../../../component/Button/Button";
import { Col, Row } from "react-bootstrap";

import upload from "../../../../images/careers/upload.svg";
import Toast from "../../../../component/Toast/Toast";
import close from "../../../../images/close.svg";
import check from "../../../../images/check.svg";
import Imageurldata from "../../../../Imageurldata";

const HeaderLogo = () => {
  const [loading, setLoading] = useState(false);

  const [logoImg, setLogoImg] = useState("");
  const [logoPreview, setLogoPreview] = useState("");
  const [logoImgErr, setLogoImgErr] = useState("");
  const [checkLogoPresent, setCheckLogoPresent] = useState(false);

  const [toastlist, setToastList] = useState([]);
  let toastProperties = null;

  const allowedExtensions = [
    "jpg",
    "jpeg",
    "png",
    "svg",
    "JPG",
    "JPEG",
    "PNG",
    "SVG",
  ];

  const validateImage = (file) => {
    if (!file) return false;
    const ext = file.name.split(".").pop();
    return allowedExtensions.includes(ext);
  };

  const showToast = (type) => {
    const id = Math.floor(Math.random() * 101 + 1);

    switch (type) {
      case "success":
        toastProperties = {
          id,
          title: "Success",
          description: "Logo Saved Successfully",
          backgroundColor: "#329F33",
          icon: check,
        };
        break;

      case "danger":
        toastProperties = {
          id,
          title: "Error",
          description: "Something went wrong",
          backgroundColor: "red",
          icon: close,
        };
        break;

      default:
        setToastList([]);
    }

    setToastList([...toastlist, toastProperties]);
  };

  const fetchHeaderLogo = () => {
    setLoading(true);

    axios({
      method: "get",
      url: urldata + "admin/getHeaderLogo",
      withCredentials: true,
    })
      .then((res) => {
        const data = res.data.data;

        if (data.length && data[0].imageUrl) {
          setLogoImg(Imageurldata + data[0].imageUrl);
          setLogoPreview(Imageurldata + data[0].imageUrl);
        } else {
          setLogoImg("");
          setLogoPreview("");
        }

        setLoading(false);
      })
      .catch(() => setLoading(false));
  };

  useEffect(() => {
    fetchHeaderLogo();
  }, []);

  const saveLogo = () => {
    let formData = new FormData();

    if (checkLogoPresent) {
      formData.append("logo", logoImg);
      setCheckLogoPresent(false);
    }

    let url = new URL(urldata + "admin/saveHeaderLogo");
    let finalUrl = decodeURIComponent(url);

    setLoading(true);
    axios({
      method: "post",
      url: finalUrl,
      data: formData,
      withCredentials: true,
    })
      .then(() => {
        setLoading(false);
        showToast("success");

        fetchHeaderLogo();
        setLogoImg("");
        setLogoPreview("");
      })
      .catch(() => {
        setLoading(false);
        showToast("danger");
      });
  };

  const submit = () => {
    let valid = true;

    if (!logoImg) {
      valid = false;
      setLogoImgErr("*Please upload Logo");
    } else setLogoImgErr("");

    if (valid) saveLogo();
  };

  return (
    <>
      <h1>Header Logo</h1>
      <br />

      <Row className="adminhomeaboutSec1">
        {/* Logo Image */}
        <Col lg={3} className="column">
          <div className="title">Header Logo:</div>
          <div className="desc">Recommended Size: 431 × 101 px</div>
        </Col>

        <Col lg={9} className="column">
          <input
            id="logoImg"
            accept=".jpg,.jpeg,.png,.svg"
            type="file"
            onChange={(e) => {
              const file = e.target.files[0];
              if (!file) return;

              if (!validateImage(file)) {
                setLogoImgErr("Invalid file! Only JPG, PNG, SVG allowed.");
                return;
              }

              setLogoImg(file);
              setLogoPreview(URL.createObjectURL(file));
              setLogoImgErr("");
              setCheckLogoPresent(true);
            }}
          />

          <label htmlFor="logoImg" className="d-f" id="file-drag">
            <img src={upload} className="img-fluid" />
            <div className="chooseTxt">Choose File</div>
          </label>

          <div className="fileTxt">File Format: JPG / JPEG / PNG / SVG</div>
          <div className="err">{logoImgErr}</div>

          {logoPreview && (
            <img
              src={logoPreview}
              alt="Logo Preview"
              style={{
                width: "120px",
                height: "60px",
                objectFit: "contain",
                marginTop: "10px",
                background: "#f5f5f5",
                padding: "10px",
                borderRadius: "8px",
              }}
            />
          )}
        </Col>

        <Col className="column d-f j-c a-c">
          <Button onClick={submit} title="SUBMIT" />
        </Col>
      </Row>

      <Toast toastList={toastlist} position="top-right" />
    </>
  );
};

export default HeaderLogo;
